import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';

import { BigButton } from '../../UI/BigButton';

import getStreamButtonPriceLabel from '../../../helpers/moviePrice/getStreamButtonPriceLabel';
import getMoviePrice from '../../../helpers/moviePrice/getMoviePrice';

import { BoughtMoviesModel } from '../../../pages/boughtMovies/query/types';
import { WishlistBookmarksModel } from '../../../pages/wishlist/query/types';

type StreamButtonType = {
  movie: BoughtMoviesModel | WishlistBookmarksModel;
  setShow: (value: boolean) => void;
  setOrderVisibility: (value: boolean) => void;
  setSelectedPrice:(value: number) => void;
  setSelectedButton:(value: string) => void;
  setSelectedMovie:(value: BoughtMoviesModel | WishlistBookmarksModel) => void;
}

const StreamButton:React.FC<StreamButtonType> = (props) => {
  const { movie,setShow,setOrderVisibility,setSelectedPrice,setSelectedButton,setSelectedMovie } = props;

  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const stream = movie.stream;
  if (!stream) return null;

  const isSubscriptionStream = stream.license_type === 'subscription-stream';
  const isFreeStream = stream.price === 0 && !!stream.hours_to_expire;
  const isBluePlusUpsell = user.subscribed === false && movie.banner === 'blue-movie-plus';

  const mdSize = isBluePlusUpsell ? 3 : 4;

  const isActive = isSubscriptionStream || isFreeStream;

  const buttonText = getStreamButtonPriceLabel(movie,movie.stream)

  const handleClick = () => {
    if (isActive) {
      setShow(true);
    } else {
      setOrderVisibility(true);
      setSelectedPrice(getMoviePrice(movie, 'stream'));
    }

    setSelectedButton('play');
    setSelectedMovie(movie);
  };

  return (
    <BigButton
      active={isActive}
      md={mdSize}
      sm={6}
      onClick={handleClick}
      icon="fa fa-play-circle"
      text={buttonText}
    />
  );
}

export default StreamButton